import React, { useContext, useEffect, useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import Switch from "react-switch";
import {
  Container,
  Relationship,
  LabelRelationship,
  Checkbox,
  TextField,
  DataPersonal,
  Label,
  TextFieldPersonal,
  GroupInput,
  DocumentInput,
  ContainerSwitch,
  LabelSwitch,
  Error,
} from "./style";
import { IOptions } from "@components/form/Select/interface";
import { getDocumentType } from "@api/services/parameterization";
import Select from "@components/form/Select";
import { bondList } from "@utils/constant/select";
import { AppContext } from "@context";
import { TypesAnonymous } from "@context/types/anonymous";
import { TypesLoading } from "@context/types/loading";
import { useLocation } from "react-router-dom";
const Natural = () => {
  const location = useLocation();
  const { state, dispatch } = useContext(AppContext);
  const { anonymous } = state;
  const [doctype, setDoctype] = useState<IOptions[]>([]);
  const { register, watch, control, setValue, errors } = useFormContext();
  const isPatient = watch("relationshipType") == 0;
  const isFamiliar = Number(watch("relationshipType")) === 1;
  const isOther = Number(watch("relationshipType")) === 3;
  const typeIssue = (location.state as { type: number }).type;
  const isCongratsOrSugestion = typeIssue === 4 || typeIssue === 3;
  /*useEffect(() => {
    register({ name: "bond" }, { required: true });
    register({ name: "docType" }, { required: true });
  });*/

  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: TypesLoading.Loading });
        const responseDocumentype = await getDocumentType();
        const doctypes = responseDocumentype.map(({ id, name }) => ({
          label: name,
          value: id,
        }));
        setDoctype(doctypes);
        dispatch({ type: TypesLoading.NotLoading });
      } catch (err) {
        dispatch({ type: TypesLoading.NotLoading });
      }
    })();
  }, []);
  const handleSelectChange = (option: IOptions, name: string) => {
    setValue(name, option);
  };
  const ChangeAnonimous = (state: boolean) => {
    if (state) {
      dispatch({ type: TypesAnonymous.Anonymous });
    } else {
      dispatch({ type: TypesAnonymous.NotAnonymous });
    }
  };
  return (
    <Container>
      <ContainerSwitch>
        <LabelSwitch>Anonimo </LabelSwitch>
        <Switch
          onColor="#90d1f4"
          offColor="#D8DDE1"
          onHandleColor="#2693e6"
          handleDiameter={15}
          width={48}
          height={22}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          checked={anonymous}
          onChange={ChangeAnonimous}
        />
      </ContainerSwitch>

      {!anonymous && (
        <>
          <Relationship>
            <LabelRelationship>Relacion: *</LabelRelationship>
            <Checkbox
              ref={register(
                isCongratsOrSugestion
                  ? { required: false }
                  : { required: !anonymous }
              )}
              name="relationshipType"
              value={"0"}
            >
              Paciente
            </Checkbox>
            <Checkbox
              ref={register(
                isCongratsOrSugestion
                  ? { required: false }
                  : { required: !anonymous }
              )}
              name="relationshipType"
              value={"1"}
            >
              Familiar
            </Checkbox>
            <Checkbox
              ref={register(
                isCongratsOrSugestion
                  ? { required: false }
                  : { required: !anonymous }
              )}
              name="relationshipType"
              value={"2"}
            >
              Cuidador(No familiar)
            </Checkbox>
            <Checkbox
              ref={register(
                isCongratsOrSugestion
                  ? { required: false }
                  : { required: !anonymous }
              )}
              name="relationshipType"
              value={"3"}
            >
              Otro
              <TextField
                ref={register(
                  isCongratsOrSugestion
                    ? { required: false }
                    : { required: isOther }
                )}
                name="relationship"
                placeholder={"Escriba su relación"}
                disabled={!isOther}
              />
            </Checkbox>
            {errors.relationship?.type === "required" && (
              <Error>Es requerido</Error>
            )}
            {errors.relationshipType?.type === "required" && (
              <Error>Es requerido</Error>
            )}
          </Relationship>
          {!isPatient && (
            <DataPersonal>
              <Label>
                Nombre completo{" "}
                <TextFieldPersonal
                  ref={register({ required: false })}
                  name="name"
                  placeholder="Escriba su nombre"
                />
                {errors.name?.type === "required" && (
                  <Error>Es requerido</Error>
                )}
              </Label>
              <Label>
                Apellidos{" "}
                <TextFieldPersonal
                  ref={register({ required: false })}
                  name="lastName"
                  placeholder="Escriba sus apellidos"
                />
                {errors.lastName?.type === "required" && (
                  <Error>Es requerido</Error>
                )}
              </Label>
              {isFamiliar && (
                <Label>
                  Vínculo{" "}
                  <Controller
                    as={Select}
                    options={bondList}
                    placeholder={"Seleccione"}
                    name={"bond"}
                    control={control}
                    rules={{ required: false }}
                    onChange={(value: IOptions) => {
                      handleSelectChange(value, "bond");
                    }}
                  />
                  {errors.bond?.type === "required" && (
                    <Error>Es requerido</Error>
                  )}
                </Label>
              )}
              <Label>
                Tipo Documento{" "}
                <GroupInput>
                  <Controller
                    as={Select}
                    options={doctype}
                    placeholder={"Seleccione"}
                    name={"docType"}
                    control={control}
                    rules={{ required: false }}
                    onChange={(value: IOptions) => {
                      handleSelectChange(value, "docType");
                    }}
                  />

                  <DocumentInput
                    ref={register({ required: false })}
                    name="documemt"
                    placeholder="Numero de documento"
                    type="number"
                  />
                </GroupInput>
                {errors.docType?.type === "required" && (
                  <Error>Es requerido</Error>
                )}
              </Label>
            </DataPersonal>
          )}
        </>
      )}
    </Container>
  );
};

export default Natural;
